import { InputGroup, NumericInput, Tag } from "@blueprintjs/core";
import React from "react";
import { compareTwoObjects } from "../fns/util";
import { inject, observer } from "mobx-react";
import _ from "lodash";
import SingleSelectWrapper from "../utils/SingleSelectWrapper";

class BedMaster extends React.Component {
  state = {
    changed: false,
  };
  componentDidMount() {
    this.setState({ ...this.props.data });
  }

  render() {
    return (
      <>
        <td>
          <SingleSelectWrapper
            items={this.props.sites}
            showSelectProp={true}
            selectedItem={this.state.site}
            onChange={(site) =>
              this.setState({ site: site, changed: true }, () =>
                this.props.onUpdate(
                  compareTwoObjects(this.state, this.props.data)
                )
              )
            }
          />
        </td>{" "}
        <td>
          <InputGroup
            value={this.state.bed}
            onChange={(event) => {
              this.setState({ bed: event.target.value, changed: true }, () =>
                this.props.onUpdate(
                  compareTwoObjects(this.state, this.props.data)
                )
              );
            }}
          />
        </td>
        <td>
          <InputGroup
            value={this.state.ward}
            onChange={(event) => {
              this.setState({ ward: event.target.value, changed: true }, () =>
                this.props.onUpdate(
                  compareTwoObjects(this.state, this.props.data)
                )
              );
            }}
          />
        </td>
        <td>
          <NumericInput
            style={{ width: "9em" }}
            value={this.state.ratePaise / 100}
            buttonPosition="NONE"
            rightElement={<Tag minimal>₹</Tag>}
            onValueChange={(number) =>
              this.setState(
                {
                  ratePaise: number * 100,
                  changed: true,
                },
                () =>
                  this.props.onUpdate(
                    compareTwoObjects(this.state, this.props.data)
                  )
              )
            }
          />
        </td>
      </>
    );
  }
}

export default inject("authStore")(observer(BedMaster));
